import { injectScript } from './utils'
import { getSpConfig } from './getSpConfig'

/**
 * Dynamically injects the Sourcepoint “wrapperMessagingWithoutDetection.js”.
 */
export function loadSpWrapper(): HTMLScriptElement | null {
  const config = getSpConfig()
  return injectScript({
    id: 'sp-wrapper',
    src: `${config.baseEndpoint}/unified/wrapperMessagingWithoutDetection.js`,
    async: true,
    type: 'text/javascript',
  })
}
